import React from 'react';
import cx from 'classnames';
import { useConfigContext } from '../config-provider';
export var ErrorTip = function (props) {
    var _a;
    var show = props.show;
    var prefixCls = useConfigContext().prefixCls;
    var tipContainerCls = prefixCls + "-input-error-tip-container";
    return (React.createElement("div", { className: cx(tipContainerCls, (_a = {},
            _a[tipContainerCls + "-show"] = show && props.children,
            _a)) }, props.children));
};
export default ErrorTip;
//# sourceMappingURL=error-tip.js.map